// EXTERNAL DEPENDENCIES
import React from 'react'

// COMPONENTS
import { Row } from '@paypalcorp/pp-react'
import { HeadingText } from '@paypalcorp/pp-react-text'

// STYLES
import { lightGrayColor } from '@/styles/colors'
import styles from './styles.module.less'

/**
 * Displays the header and subheader of each panel step
 */
export default function SectionHeader({
  headerText,
  subheaderText,
  isLoading,
}: Readonly<{
  headerText: string
  subheaderText: string
  isLoading?: boolean
}>) {
  return (
    <Row noGutters className={styles.sectionHeaderContainer}>
      <HeadingText
        level={1}
        className={styles.headerContainer}
        isLoading={isLoading}
      >
        {headerText}
      </HeadingText>
      <HeadingText
        level={2}
        style={{ color: lightGrayColor }}
        isLoading={isLoading}
      >
        {subheaderText}
      </HeadingText>
    </Row>
  )
}
